import { Component, OnInit } from '@angular/core';
import { FormBuilder,FormGroup,Validators } from '@angular/forms';
import { SignupService } from '../services/signup.service'
import { Router } from '@angular/router';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  constructor(private formBuilder : FormBuilder,private Signup : SignupService,private router: Router) { }
  Msg;
  RespMsg;
  form: FormGroup;
  ngOnInit() {
    let Userid = localStorage.getItem("Userid");
    console.log('Userid', Userid);
    if (Userid!=null) {
    //this.router.navigate(['/Dashboard']);
    }
    this.InitForm();
  }
  InitForm()
  {
    this.form = this.formBuilder.group({
      username:['', Validators.required],
      password:['', Validators.required]
    });
  }
  onLogin(clientData)
  {
    this.Msg ='Wait';
    //console.log(clientData);
    const formData = new FormData();
    formData.append('username', clientData.username);
    formData.append('password', clientData.password);
    this.Signup.LoginActivity(formData).subscribe(
      (res:any) => {
        this.RespMsg =res.msg;
        //console.log(res);
        this.InitForm();
        if(res.code==1){
          localStorage.setItem("UID",res.id);
          localStorage.setItem("mobile",res.mobile);
          localStorage.setItem("usertype",res.user_type);
        this.router.navigate(['/verify']);
        }
        this.Msg ='';
      }
    );  
  }
}
